import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { renderSelect } from '../../../lib/helper/form';
import { connect } from 'react-redux';
import { emailResponseListSetFilters, emailResponseListClearFilters, emailResponseListSetPage } from '../../../lib/redux/actions/emailResponses';
import Form from 'react-bootstrap/Form';

const isActionedOptions = [
  { value: 0, text: 'UnActioned' },
  { value: 1, text: 'Actioned' },
];

const mapStateToProps = () => {
  return {
    initialValues: {
      isActioned: 0,
    },
  };
};

const mapDispatchToProps = {
  emailResponseListSetPage,
  emailResponseListSetFilters,
  emailResponseListClearFilters,
};

class EmailResponseTableFilterForm extends React.Component {
  constructor(props) {
    super(props);

    const { initialize, initialValues } = this.props;
    initialize(initialValues);
  }

  onSubmit(values) {
    const filters = {};
    if (Number(values.isActioned) === 1) {
      filters.isActioned = true;
    } else {
      filters.isActioned = false;
    }
    this.props.emailResponseListSetPage(1);
    this.props.emailResponseListSetFilters(filters);
  }

  resetFilters() {
    const { reset, emailResponseListClearFilters } = this.props;
    emailResponseListClearFilters();
    reset();
  }

  render() {
    const { handleSubmit, error } = this.props;

    return (
      <div>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))} className="form-inline form-data-filters">
          <Field name="isActioned" label="Status" options={isActionedOptions} showEmpty={false} component={renderSelect} />
          <div className="filter-actions">
            <button type="submit" className="btn btn-primary btn-sm">
              Filter
            </button>
            <button type="button" className="btn btn-outline-danger btn-sm ml-2" onClick={this.resetFilters.bind(this)}>
              Reset
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'EmailResponseTableFilterForm',
})(connect(mapStateToProps, mapDispatchToProps)(EmailResponseTableFilterForm));
